import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import type { BlogPost } from '../../../../shared/models/blog.model';
import { BlogDatePipe, BlogReadTimePipe } from '../../pipes/blog-format.pipes';

@Component({
  selector: 'app-blog-card',
  imports: [RouterLink, BlogDatePipe, BlogReadTimePipe],
  templateUrl: './blog-card.component.html',
  styleUrl: './blog-card.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'contents' },
})
export class BlogCardComponent {
  post = input.required<BlogPost>();
}
